module.exports = __webpack_public_path__ + "img/icon_list_good_selected2.5f6855f9.svg";